<template>
    <router-link to="/sbmptn" tag="li"><a><i class="fa fa-pencil"></i><span>SNBT</span></a></router-link>
</template>
<script>
export default {
    name: 'sbmptn-nav'
}
</script>



// WEBPACK FOOTER //
// Navigation.vue?239a42ba